// Hand-off from the new payment UI (payment-web-ui): when it sends a user back here
// (merchant unknown to the new backend), a full-page cross-origin redirect cannot call
// our window.setPayload directly, so the payload arrives in the URL fragment
// (#payload=<encoded JSON>). Read it once, then strip it so the token does not linger
// in the URL/history. Mirror of payment-web-ui's readPayloadFromHash.
function readPayloadFromHash() {
    const { hash } = window.location;
    const match = hash.match(/[#&]payload=([^&]+)/);

    if (!match) {
        return null;
    }

    try {
        const parsed = JSON.parse(decodeURIComponent(match[1]));

        const cleanedHash = hash.replace(/([#&])payload=[^&]+/, '$1').replace(/[#&]$/, '');
        window.history.replaceState(
            null,
            '',
            window.location.pathname + window.location.search + cleanedHash,
        );

        return parsed;
    } catch (e) {
        return null;
    }
}

export default readPayloadFromHash;
